// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import UnreadChannelIndicator from './unread_channel_indicator';

export default UnreadChannelIndicator;
